<mat-radio-group
  [(ngModel)]="value"
  aria-label="Select an option"
  (change)="radioGroupChange($event)"
  [disabled]="disabled"
  >
  @if (options) {
    @for (option of options | keyvalue: formControlsService.pipeComparator; track option) {
      <mat-radio-button
        color="primary"
        [value]="option.key"
        >{{ option.value }}</mat-radio-button
        >
      }
    }

    @if (advancedOptions) {
      @for (option of advancedOptions; track option) {
        <mat-radio-button
          color="primary"
          [disabled]="option.disabled || false"
          [value]="option.value"
          >{{ option.label }}</mat-radio-button
          >
        }
      }
    </mat-radio-group>
